module.exports = __webpack_public_path__ + "media/images/common/search_btn-05cef956c6bb0fd90f148fc397c05cab.gif";